<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <status-list-filter
      @edit="editComponentFilters($event, 'filter__status__in')"
      @clean="cleanComponentFilters(['filter__status__in'])"
    />
    <customer-contact-list-filter
      @edit="editComponentFilters($event, 'filter__contact__in')"
      @clean="cleanComponentFilters(['filter__contact__in'])"
    />
    <order-done-list-filter
      @edit="editComponentFilters($event, 'filter__order_done')"
      @clean="cleanComponentFilters(['filter__order_done'])"
    />
    <submitted-list-filter
      @edit="editComponentFilters($event, 'filter__submitted')"
      @clean="cleanComponentFilters(['filter__submitted'])"
    />
    <!-- <owner-contact-list-filter
      @edit="editComponentFilters($event, 'filter__owner__in')"
      @clean="cleanComponentFilters(['filter__owner__in'])"
    /> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as QUOTATION_TYPES } from './store'
import CommonFiltersMixin from '../../common-filters/CommonFiltersMixin'

export default {
  name: 'QuotationCommonFilters',
  mixins: [CommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: QUOTATION_TYPES.GENERIC.quotation.quotation.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...QUOTATION_TYPES.GENERIC.quotation.quotation.LIST.ACTIONS
    })
  }
}
</script>
